import { defineComponent as _defineComponent } from 'vue';
import { EnItem } from 'Components/base/EnItem';
import EnTooltip from 'Components/base/EnTooltip/EnTooltip.vue';
import { cn } from 'Components/primitives/utils';
export default /*@__PURE__*/ _defineComponent({
    ...{
        inheritAttrs: false,
    },
    __name: 'EnMenuItem',
    props: {
        disabled: { type: Boolean, required: false, default: false },
        disabledTooltip: { type: [String, null], required: false, default: null },
        active: { type: Boolean, required: false, default: false },
        staticId: { type: [String, null], required: false, default: null },
        tooltipPosition: { type: null, required: false, default: 'left' },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true, default: undefined }
    },
    emits: ["click"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        function onClick(event) {
            if (props.disabled) {
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            emit('click', event);
        }
        const __returned__ = { props, emit, onClick, get EnItem() { return EnItem; }, EnTooltip, get cn() { return cn; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
